import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import * as PIXI from 'pixi.js';
import { gsap, CustomEase } from 'gsap';
import { PixiPlugin } from 'gsap/PixiPlugin.js';
import { MotionPathPlugin } from 'gsap/MotionPathPlugin.js';

import reportWebVitals from './reportWebVitals';
import { init } from './core/init';

import 'react-toastify/dist/ReactToastify.css';
import './index.scss';
import { polyfill } from './core/polyfill';
import { PlatformMessagesWrapper } from './components/PlatformMessagesWrapper';

window.PIXI = PIXI;
require('pixi-spine');

gsap.registerPlugin(PixiPlugin, MotionPathPlugin, CustomEase);

const App = React.lazy(() => import('./App'));

polyfill();

init();

ReactDOM.render(
  <React.StrictMode>
    <Suspense fallback={null}>
      <PlatformMessagesWrapper>
      <App/>
        </PlatformMessagesWrapper>
    </Suspense>
  </React.StrictMode>,
  document.getElementById('root'),
);

reportWebVitals();
